module.exports = __webpack_public_path__ + "static/img/login01_09.d0faf9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/login01_09.png
// module id = /roR
// module chunks = 0